import React, { useContext } from 'react';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import { useHistory } from "react-router-dom";
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import CheckBoxOutlineBlankTwoToneIcon from '@material-ui/icons/CheckBoxOutlineBlankTwoTone';

import StudentContext from '../../../context/student-context';
import AssementContext from '../../../context/learningContentContext/assement-context';
import { postAssessment,postAssessmentNR } from './../../../actions/learningcontent-actions'
import { getStudentCoins } from '../../../actions/share-actions';
import Loading from '../../shared/Loading'
import FlyingCoinAnimationModal from '../../shared/modals/FlyingCoinAnimationModal'
import ExtraMaxLevelAssetModal from '../../shared/modals/ExtraMaxLevelAssetModal'
import { DialogLearningContent } from '../../shared/component'
import useStyles from '../../../styles/components/learningcontent/stylesAssessmentHolder'

import { StudentProfile, AssementData } from '../../../utils/services/cache/ClientCache'
import { getLearningContentFromSession, getStudentNumberFromSession, getTime, setTime } from '../../../utils/helpers/others/SessionHelper'

const AssementHolder = () => {
    const history = useHistory();
    const classes = useStyles();
    const [isLoading, setIsLoading] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [notiOpen, setNotiOpen] = React.useState(false);
    const [extraAssetOpen, setExtraAssetOpen] = React.useState(false);
    const [isNotFullMarks, setIsNotFullMarks] = React.useState(false);
    const [assementRewardPoint, setAssementRewardPoint] = React.useState(0);
    const [messageReward, setMessageReward] = React.useState('')
    const { dispatchStudent } = useContext(StudentContext);
    const { assementContext, dispatch } = useContext(AssementContext);
    let learningContentSession = JSON.parse(getLearningContentFromSession());
    let currentRewardPoint = StudentProfile.getRewardPoint();
    const [snackBarDetails, setSnackBarDetails] = React.useState({
        open: false,
        message: '',
        type: '',
    });

    const handleRedoClick = () => {
        setOpen(false);
    }

    const handleSnackBarClose = () => setSnackBarDetails({ ...snackBarDetails, open: false });

    const inputSnackBarDetails = (message, type) => setSnackBarDetails({
        open: true,
        message,
        type
    });

    if (typeof assementContext === 'undefined') return <Loading />;

    const handleChange = event => dispatch({ type: 'SET_SECRET_CODE', secretCode: event.target.value });

    const handleChangeCheckbox = (answer, content, index) => event => {
        let size = 0;
        content.answers.forEach(element => {
            if (element.isChecked) size += 1
        });
        let limit = content.limit
        if (answer.isChecked) {
            answer.isChecked = false
        }
        else if (size < limit || limit <= 0) {
            answer.isChecked = true
        }

        
        dispatch({ type: 'SET_MULTIPLECHOICE_CONTENTS', multipleChoiceContents: assementContext.multipleChoiceContents });
    };

    const checkValidation = () => {
        let isError = false;

        if (assementContext.multipleChoiceContents.length > 0) {
            if (assementContext.assessmentTypeName === 'Multiple Choice' || assementContext.assessmentTypeName === 'Multiple Choice and Secret Code') {
                assementContext.multipleChoiceContents.map(item => {
                    if (Object.keys(item.selectedAnswer).length === 0) {
                        inputSnackBarDetails("Answers can't be empty", 'error');
                        return isError = true;
                    }
                })
            }
            else if (assementContext.assessmentTypeName === 'Multiple Answers' || assementContext.assessmentTypeName === 'Multiple Answers and Secret Code') {
                assementContext.multipleChoiceContents.map(item => {
                    let index = item.answers.findIndex(element => element.isChecked === true)
                    if (index === -1) {
                        inputSnackBarDetails("Answers can't be empty", 'error');
                        return isError = true;
                    }
                })
            }
        }
        return isError;
    }

    const submitAssement = async () => {

        if (!checkValidation()) {
            setIsLoading(true);
            let maxScore = assementContext.multipleChoiceContents.length;
            let score = 0;
            let rewardPoint = AssementData.getAssementRewardPoint();
            let studentNumber = getStudentNumberFromSession();
            let wrongAnswers = [];

            if (assementContext.multipleChoiceContents.length > 0) {
                if (assementContext.assessmentTypeName === 'Multiple Choice' || assementContext.assessmentTypeName === 'Multiple Choice and Secret Code') {
                    assementContext.multipleChoiceContents.forEach((item,index) => {
                        if (item.selectedAnswer.isCorrect)
                            score += 1;
                        else{
                            // console.log("Hint activated for "+ item.question.questionContent);
                            // console.log(item.question);
                            wrongAnswers.push(index);
                        }
                    })
                }            
                else if (assementContext.assessmentTypeName === 'Multiple Answers' || assementContext.assessmentTypeName === 'Multiple Answers and Secret Code') {
                    assementContext.multipleChoiceContents.forEach((item,index) => {
                        let count = 0
                        item.answers.forEach(element => {
                            if (element.isCorrect === element.isChecked && element.isCorrect === true) {
                                count += 1
                            }
                        });
                        if (item.limit === count) {
                            score += 1;
                        } //else wrong answer +1, add question into hint list
                        else{
                            item.hintOn = true;
                            wrongAnswers.push(index);                            
                        }
                    })
                }
            }
             //end of MCQ content answers

            let assessmentTypeName = ''
            if (assementContext.assessmentTypeName === 'Multiple Choice' || assementContext.assessmentTypeName === 'Multiple Choice and Secret Code') {
                assessmentTypeName = 'MCQ';
            } else if (assementContext.assessmentTypeName === 'Multiple Answers' || assementContext.assessmentTypeName === 'Multiple Answers and Secret Code') {
                assessmentTypeName = 'Multiple Answers';
            } else {
                assessmentTypeName = 'Secret Code';
                score = 0;
                maxScore = 0;
            }

            const startTime = getTime();
            const endTime = new Date().getTime()

            let bodyFormData = {
                learningContentId: learningContentSession.learningContentId,
                totalScore: maxScore,
                score: score,
                secretCodeText: assementContext.secretCode,
                assessmentTypeName: assessmentTypeName,
                studentNumber: studentNumber,
                isSecretCode: assementContext.isSecretCode,
                traitGroupId: AssementData.getAssementTraitGroupId(),
                rewardCoins: rewardPoint,
                duration: Math.round((endTime - startTime) / 1000)
            };
            let response = null;

            if(learningContentSession.isAccessible){
                response = await postAssessment(JSON.stringify(bodyFormData));
            }
            else{
                response = await postAssessmentNR(JSON.stringify(bodyFormData));
            }

            if (response > 200 || response.status === "Failed" || response === null) {
                return history.push("/SessionTimeOut")
            }


            setIsLoading(false);
            if (parseInt(response.data.coinEarned) > 0 || response.data.noEarnCoinMessage) {

                if (response.data.isExtraMaxLevel)
                    setExtraAssetOpen(true)
                else if (response.data.noEarnCoinMessage){
                    setOpen(true);  
                }
                else
                    setNotiOpen(true)

                setAssementRewardPoint(response.data.coinEarned);
                let message = response.data.message;
                if(score < maxScore ){
                    setIsNotFullMarks(true);                    
                    message = message + ". You have " + (maxScore - score) + " incorrect answers ["
                    for (let i = 0; i < wrongAnswers.length; i++) {
                        if(i == 0)
                            message = message + "Q" + (wrongAnswers[i]+1);
                        else
                            message = message + ", Q" + (wrongAnswers[i]+1);
                    }
                    message = message + "]. Keep Going!";
                }
                else{
                    setIsNotFullMarks(false);
                }
                setMessageReward(message)
                setTime(new Date().getTime())
            }
            else {
                let message = response.data.message;
                message = message + ". You have " + (maxScore - score) + " incorrect answers ["
                for (let i = 0; i < wrongAnswers.length; i++) {
                    if(i == 0)
                        message = message + "Q" + (wrongAnswers[i] + 1);
                    else
                        message = message + ", Q" + (wrongAnswers[i]+1);
                }
                message = message + "]. Keep Going!";
                inputSnackBarDetails(message , 'error');
            }
        }
    }

    const getCurrentAnswerObject = (items, selectedValue) => {
        let item = items.find((item) => {
            if (item.options === selectedValue)
                return item
        })
        return item;
    }

    const handleCatalogClick = () => {
        if (learningContentSession.learningContentCategoryId === 0)
            return history.push("/NonTraitLearningContents");
        else
            return history.push("/LearningContents");

    };

    const handleRewatchClick = ()=>{
        return history.push("/LearningContent/");
    }
 
    const notiCloseClick = async () => {
        // update coin for Drawer Header
        const responseCoin = await getStudentCoins();
        if (responseCoin.status === "Success") {
            dispatchStudent({ type: 'SET_STUDENT_COINS', studentCoins: responseCoin.data });
        }
        setNotiOpen(false);
        setOpen(true);
    }

    const extraAssetCloseClick = async () => {
        setExtraAssetOpen(false);
        setNotiOpen(true);
    }

    if (isLoading) return <Loading />

    return (
        <>
            <Grid container direction="column" justify='center'>
                <div>
                    {assementContext.multipleChoiceContents.length > 0 &&
                        <>
                            {assementContext.multipleChoiceContents[assementContext.multipleChoiceContents.length - 1].question.assessmentType === "Multiple Choice" ?
                                <List >
                                    {assementContext.multipleChoiceContents.map((content, index) => (
                                        <div key={index}>
                                            <Grid container>
                                                <Grid item xs={12} sm={12}>
                                                    <Typography classes={{ root: classes.rootTitle }}>Q{index + 1} : {content.question.questionContent}</Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <FormControl component="fieldset" classes={{ root: classes.rootAnswers }}>
                                                        <RadioGroup aria-label="mc" name="mc1" value={Object.keys(content.selectedAnswer).length === 0 ? null : content.selectedAnswer.options}
                                                            onChange={(event) => {
                                                                content.selectedAnswer = getCurrentAnswerObject(content.answers, event.target.value)
                                                                assementContext.multipleChoiceContents[index] = content
                                                                dispatch({ type: 'SET_MULTIPLECHOICE_CONTENTS', multipleChoiceContents: assementContext.multipleChoiceContents });
                                                            }}>
                                                            {content.answers.map((answer, index) => (
                                                                <FormControlLabel key={index} value={answer.options}
                                                                    control={<Radio />}
                                                                    label={<Typography classes={{ root: classes.rootDescription }}>{answer.options}</Typography>}
                                                                />
                                                            ))}
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    ))}
                                </List>
                                :
                                <List >
                                    {assementContext.multipleChoiceContents.map((content, index) => (
                                        <div key={index}>
                                            <Grid container>
                                                <Grid item xs={12} sm={12}>
                                                    <Typography classes={{ root: classes.rootTitle }}>{content.question.questionContent}</Typography>
                                                    <Typography classes={{ root: classes.rootDescription }}>Please select {content.limit} correct {content.limit > 1 ? "answers" : "answer"}</Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <FormControl component="fieldset" classes={{ root: classes.rootAnswers }}>
                                                        {content.answers.map((answer, index) => (
                                                            <FormGroup key={index}>
                                                                <FormControlLabel
                                                                    control={<Checkbox icon={<CheckBoxOutlineBlankTwoToneIcon classes={{ root: classes.checkbox }} />} checkedIcon={<CheckBoxOutlinedIcon />} checked={answer.isChecked} onChange={handleChangeCheckbox(answer, content, index)} value={answer.options} />}
                                                                    label={<Typography classes={{ root: classes.rootDescription }}>{answer.options}</Typography>}
                                                                />
                                                            </FormGroup>
                                                        ))}
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <br />
                                        </div>
                                    ))}
                                </List>
                            }
                        </>
                    }
                    {assementContext.isSecretCode &&
                        <Grid container direction="column" justify="center" alignItems="center">
                            <TextField id="outlined-basic" InputLabelProps={{ shrink: false }} label={!assementContext.secretCode ? "Secret Code" : ""} color="secondary" variant="outlined"
                                value={assementContext.secretCode}
                                onChange={handleChange}
                                classes={{ root: classes.rootTextField }}
                            />
                        </Grid>
                    }
                </div>
            </Grid>
            <Grid container direction="column" justify="center" alignItems="center">
                <Chip
                    classes={{ root: classes.rootSubmit }}
                    label='Submit'
                    onClick={() => submitAssement()}
                />
            </Grid>

            <DialogLearningContent
                open={open}
                handleCatalogClick={() => handleCatalogClick()}
                handleRedoClick={()=>handleRedoClick()}
                handleRewatchClick = {()=>handleRewatchClick()}
                isNotFullMarks = {isNotFullMarks}
                code={assementContext.secretCode}
                coinEarn={assementRewardPoint}
                coinBalance={parseInt(currentRewardPoint) + assementRewardPoint}
                message={messageReward}
            />

            <Snackbar
                anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
                key={`bottom, center`}
                open={snackBarDetails.open}
                autoHideDuration={6000}
                onClose={handleSnackBarClose}>
                <Alert onClose={handleSnackBarClose} severity={snackBarDetails.type}>
                    {snackBarDetails.message}
                </Alert>
            </Snackbar>
            <FlyingCoinAnimationModal _isOpen={notiOpen} _notiCloseClick={notiCloseClick} _extraContent={{ rewardPoint: assementRewardPoint, message: messageReward }} />
            <ExtraMaxLevelAssetModal _isOpen={extraAssetOpen} _notiCloseClick={extraAssetCloseClick} _extraContent={{ studentNumber: getStudentNumberFromSession(), traitGroupId: AssementData.getAssementTraitGroupId() }} />
        </>
    );
}

export { AssementHolder as default }